/**
 * 数字输入
 */
import React from 'react';
import { Input, InputProps } from 'antd';

const NUM_REG = /^-?\d*(\.\d*)?$/;

export interface NumberInputProps extends Pick<InputProps, Exclude<keyof InputProps, 'onChange'>> {
  onChange: (value: string) => void;
  innerRef?: any;
}

const Index: React.FC<NumberInputProps> = (props) => {
  const { value, onChange, innerRef, disabled, ...extra } = props;

  const propsValue = value ?? ''; // 默认值

  // 输入回调
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (disabled) return;
    const inputVal = event.target.value;
    if (
      (!Number.isNaN(inputVal) && NUM_REG.test(inputVal)) ||
      inputVal === '' ||
      inputVal === '-'
    ) {
      onChange(inputVal);
    }
  };

  return (
    <Input
      {...extra}
      disabled={disabled}
      ref={innerRef}
      value={propsValue}
      onChange={handleChange}
    />
  );
};

export default Index;
